import React from 'react';
import moment from 'moment';
import { Divider, Popconfirm, Badge } from 'antd';

export default (self, s) => [
  {
    title: '知识点标题',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 90,
    render: t => (
      <div className={s.statusBadge}>
        <Badge
          status={t === 'on' ? 'processing' : 'default'}
          text={t === 'on' ? '启用' : '停用'}
        />
      </div>
    ),
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 190,
  },
  {
    title: '有效期',
    dataIndex: 'timeout',
    key: 'timeout',
    width: 120,
    render: t => moment(t).format('YYYY-MM-DD'),
  },
  {
    title: '操作',
    dataIndex: 'x',
    key: 'x',
    width: 120,
    render: (t, item) => (
      <div>
        <a
          onClick={() => {
            self.setModals({
              key: 'updateForm',
              title: '编辑知识分类',
              item,
              visible: true,
            });
          }}
        >
          编辑
        </a>
        <Divider type="vertical" />
        <Popconfirm
          title={`确认${item.status === 'on' ? '停用？' : '启用？'}`}
          placement="left"
          okText="确认"
          cancelText="取消"
          onConfirm={() => self.triggerStatus(item.id, item.status)}
        >
          <a>{item.status === 'on' ? '停用' : '启用'}</a>
        </Popconfirm>
      </div>
    ),
  },
];
